// /* eslint-disable react-hooks/exhaustive-deps */
// import { useEffect, useState } from 'react';
// import {
//     Box,
//     Checkbox,
//     Input,
//     InputGroup,
//     InputLeftElement,
//     Radio,
//     RadioGroup,
//     Stack,
//     VStack,
//     Spinner,
// } from '@chakra-ui/react';
// import { BsSearch } from 'react-icons/bs';
// import useDebounce from 'hooks/useDebounce';
// import { apiService } from 'services/service';
// import { isEmpty } from 'lodash';

// export default function CheckList({
//     listItems,
//     selected,
//     setSelected,
//     selectOne,
//     searchApi, // API endpoint for searching (optional)
// }) {
//     const [searchInput, setSearchInput] = useState('');
//     const [found, setFound] = useState(() => listItems || []);
//     const [loading, setLoading] = useState(false);
//     const debouncedValue = useDebounce(searchInput, 500);

//     useEffect(() => {
//         if (!isEmpty(listItems) && isEmpty(found)) {
//             setFound(listItems);
//         }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [listItems]);
//     useEffect(() => {
//         let timeoutId;

//         const fetchSearchResults = async () => {
//             if (!debouncedValue) {
//                 setFound(listItems);
//                 return;
//             }

//             if (searchApi && debouncedValue) {
//                 setLoading(true);
//                 try {
//                     const response = await apiService.get(
//                         `${searchApi}=${encodeURIComponent(debouncedValue)}`,
//                     );
//                     if (response.data.contacts) {
//                         const data = response.data.contacts.map((item) => ({
//                             ...item,
//                             name: item.contact_name,
//                         }));
//                         setFound(data);
//                     }
//                 } catch (error) {
//                     console.error('Error fetching search results:', error);
//                     setFound([]);
//                 } finally {
//                     setLoading(false);
//                 }
//             } else {
//                 // Local filtering if no API is provided
//                 const res = listItems.filter((item) =>
//                     item.name.match(new RegExp(debouncedValue, 'i')),
//                 );
//                 setFound(res);
//             }
//         };

//         // Debounce API calls
//         timeoutId = setTimeout(fetchSearchResults, 300);

//         return () => clearTimeout(timeoutId);
//     }, [debouncedValue, searchApi]);

//     const onChange = (e) => {
//         if (selected?.includes(e.target.value) && !e.target.checked && !selectOne) {
//             const res = selected?.filter((s) => s !== e.target.value);
//             setSelected(res);
//         } else if (selectOne) {
//             setSelected([e.target.value]);
//         } else {
//             setSelected([...selected, e.target.value]);
//         }
//     };

//     return (
//         <VStack alignItems="start" px={{ base: '2', lg: '10' }} spacing="4">
//             <Box>
//                 <InputGroup>
//                     <InputLeftElement pointerEvents="none" color="gray.300" fontSize="1.2em">
//                         <BsSearch />
//                     </InputLeftElement>
//                     <Input
//                         value={searchInput}
//                         w="full"
//                         onChange={(e) => setSearchInput(e.target.value)}
//                         placeholder="Search"
//                     />
//                 </InputGroup>
//             </Box>

//             {loading ? (
//                 <Spinner />
//             ) : selectOne ? (
//                 <RadioGroup>
//                     <Stack>
//                         {found?.map((item, i) => (
//                             <Radio
//                                 key={i}
//                                 onChange={(e) => onChange(e)}
//                                 value={item.name}
//                                 isTruncated
//                                 max-w="200px">
//                                 <span
//                                     style={{
//                                         display: 'block',
//                                         maxWidth: '200px',
//                                         overflow: 'hidden',
//                                     }}>
//                                     {item.name}
//                                 </span>
//                             </Radio>
//                         ))}
//                     </Stack>
//                 </RadioGroup>
//             ) : (
//                 found?.map((item, i) => (
//                     <Checkbox onChange={(e) => onChange(e)} key={i} value={item.name}>
//                         {item.name}
//                     </Checkbox>
//                 ))
//             )}
//         </VStack>
//     );
// }

/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, memo, useCallback } from 'react';
import {
    Box,
    Flex,
    Text,
    Checkbox,
    Input,
    InputGroup,
    InputLeftElement,
    Radio,
    RadioGroup,
    VStack,
    Spinner,
} from '@chakra-ui/react';
import useDebounce from 'hooks/useDebounce';
import { apiService } from 'services/service';
import { isEmpty } from 'lodash';

/* ─────────────────────────────────────────────────────────────
   BRAND TOKENS
   ───────────────────────────────────────────────────────────── */

const NAVY        = '#1B3B5F';
const CYAN        = '#DCF8F9';
const INK         = '#1A2740';
const MUTED       = '#5A6B7E';
const FAINT       = '#8896AE';
const SURFACE     = '#FFFFFF';
const SURFACE_ALT = '#F7F9FB';
const BORDER      = '#E8EDF5';

const FONT = "'Bricolage Grotesque', sans-serif";

/* ─────────────────────────────────────────────────────────────
   ICONS
   ───────────────────────────────────────────────────────────── */

const SearchIcon = (props) => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" {...props}>
        <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
        <path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

const InboxIcon = (props) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M22 12h-6l-2 3h-4l-2-3H2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.5 5h13l3 7v6a2 2 0 01-2 2h-15a2 2 0 01-2-2v-6l3-7z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    </svg>
);

/* ─────────────────────────────────────────────────────────────
   ITEM PRIMITIVE — wraps Radio or Checkbox in a tappable row
   ───────────────────────────────────────────────────────────── */

const ListItem = memo(function ListItem({
    value, label, isSelected, onChange, controlType,
}) {
    const Control = controlType === 'radio' ? Radio : Checkbox;

    return (
        <Flex
            as="label"
            align="center"
            gap="10px"
            px="8px"
            py="6px"
            borderRadius="6px"
            cursor="pointer"
            transition="background 0.12s ease"
            _hover={{ bg: SURFACE_ALT }}
            _focusWithin={{ bg: SURFACE_ALT }}
        >
            <Control
                value={value}
                onChange={onChange}
                isChecked={isSelected}
                size="sm"
                colorScheme="blue"
                sx={{
                    '& .chakra-radio__control, & .chakra-checkbox__control': {
                        w: '14px',
                        h: '14px',
                        borderColor: BORDER,
                        _checked: {
                            bg: NAVY,
                            borderColor: NAVY,
                            _hover: { bg: NAVY, borderColor: NAVY },
                        },
                        _focus: {
                            boxShadow: `0 0 0 2px ${CYAN}`,
                        },
                    },
                }}
            />
            <Text
                as="span"
                fontSize="12px"
                fontWeight={isSelected ? '600' : '500'}
                color={isSelected ? INK : MUTED}
                noOfLines={1}
                flex="1"
                minW="0"
                fontFamily={FONT}
            >
                {label}
            </Text>
        </Flex>
    );
});

/* ─────────────────────────────────────────────────────────────
   MAIN
   ───────────────────────────────────────────────────────────── */

export default function CheckList({
    listItems,
    selected,
    setSelected,
    selectOne,
    searchApi, /* optional API endpoint for searching */
}) {
    const [searchInput, setSearchInput] = useState('');
    const [found, setFound] = useState(() => listItems || []);
    const [loading, setLoading] = useState(false);
    const debouncedValue = useDebounce(searchInput, 500);

    /* Keep `found` in sync with `listItems` when no search is active.
       Fixes the stale-list bug in the original where the list wouldn't
       update if more items arrived from upstream. */
    useEffect(() => {
        if (!searchInput) {
            setFound(listItems || []);
        }
    }, [listItems, searchInput]);

    /* Debounced search — API if provided, otherwise local filter */
    useEffect(() => {
        let cancelled = false;

        const fetchSearchResults = async () => {
            if (!debouncedValue) {
                setFound(listItems || []);
                return;
            }

            if (searchApi) {
                setLoading(true);
                try {
                    const response = await apiService.get(
                        `${searchApi}=${encodeURIComponent(debouncedValue)}`
                    );
                    if (!cancelled && response.data?.contacts) {
                        const data = response.data.contacts.map((item) => ({
                            ...item,
                            name: item.contact_name,
                        }));
                        setFound(data);
                    }
                } catch (error) {
                    console.error('Error fetching search results:', error);
                    if (!cancelled) setFound([]);
                } finally {
                    if (!cancelled) setLoading(false);
                }
            } else {
                /* Local filter */
                try {
                    const re = new RegExp(debouncedValue, 'i');
                    const res = (listItems || []).filter((item) =>
                        item?.name && re.test(item.name)
                    );
                    if (!cancelled) setFound(res);
                } catch {
                    /* Invalid regex (rare) — fall back to substring */
                    const lower = debouncedValue.toLowerCase();
                    const res = (listItems || []).filter((item) =>
                        item?.name?.toLowerCase().includes(lower)
                    );
                    if (!cancelled) setFound(res);
                }
            }
        };

        fetchSearchResults();
        return () => { cancelled = true; };
    }, [debouncedValue, searchApi]);

    const handleChange = useCallback(
        (e) => {
            const value = e.target.value;
            const checked = e.target.checked;

            if (selectOne) {
                /* Radio: replace selection */
                setSelected([value]);
                return;
            }

            /* Checkbox: toggle in/out of array */
            if (checked) {
                setSelected([...(selected ?? []), value]);
            } else {
                setSelected((selected ?? []).filter((s) => s !== value));
            }
        },
        [selected, setSelected, selectOne]
    );

    const isEmptyResult = !loading && isEmpty(found);

    /* Group props share the onChange handler between Radio/Checkbox */
    const ItemRow = ({ item, i }) => {
        const isSelected = (selected ?? []).includes(item.name);
        return (
            <ListItem
                key={item.id ?? item.name ?? i}
                value={item.name}
                label={item.name}
                isSelected={isSelected}
                onChange={handleChange}
                controlType={selectOne ? 'radio' : 'checkbox'}
            />
        );
    };

    return (
        <VStack align="stretch" spacing="6px" w="full">
            {/* Search input */}
            <InputGroup size="sm">
                <InputLeftElement pointerEvents="none" h="32px">
                    <Box color={FAINT}>
                        <SearchIcon />
                    </Box>
                </InputLeftElement>
                <Input
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                    placeholder="Search"
                    h="32px"
                    pl="32px"
                    fontSize="12px"
                    bg={SURFACE_ALT}
                    border="1px solid"
                    borderColor={BORDER}
                    borderRadius="8px"
                    color={INK}
                    fontFamily={FONT}
                    _placeholder={{ color: FAINT }}
                    _hover={{ borderColor: '#CBD5E0' }}
                    _focus={{
                        borderColor: NAVY,
                        boxShadow: `0 0 0 3px ${CYAN}`,
                        bg: SURFACE,
                    }}
                />
            </InputGroup>

            {/* Results */}
            {loading ? (
                <Flex justify="center" py="20px">
                    <Spinner size="sm" color={NAVY} thickness="2px" />
                </Flex>
            ) : isEmptyResult ? (
                <Flex direction="column" align="center" justify="center" py="18px" gap="6px">
                    <Box color={FAINT}>
                        <InboxIcon />
                    </Box>
                    <Text fontSize="11px" color={FAINT} fontFamily={FONT}>
                        {searchInput ? `No results for "${searchInput}"` : 'No items available'}
                    </Text>
                </Flex>
            ) : selectOne ? (
                <RadioGroup value={(selected ?? [])[0] ?? ''}>
                    <VStack align="stretch" spacing="2px">
                        {found.map((item, i) => (
                            <ItemRow key={item.id ?? item.name ?? i} item={item} i={i} />
                        ))}
                    </VStack>
                </RadioGroup>
            ) : (
                <VStack align="stretch" spacing="2px">
                    {found.map((item, i) => (
                        <ItemRow key={item.id ?? item.name ?? i} item={item} i={i} />
                    ))}
                </VStack>
            )}
        </VStack>
    );
}